export const setEmails = ({ commit }, payload) => {
  commit('updateEmails', payload);
};
